import React, { useEffect, useState } from "react";
import paymentStore from "../../../stores/paymentStore";
import orderStore from "../../../stores/orderStore";
import usersStore from "../../../stores/usersStore";
import productStore from "../../../stores/productStore";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
} from "@mui/material";
import OrderColumn from "../OrderColumn";
import OrderRow from "../OrderRow";

// Icon
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";

const OutOfDeliveryOrderTab = ({ dataLoading }) => {
  const PaymentStore = paymentStore();
  const OrderStore = orderStore();
  const UsersStore = usersStore();
  const ProductStore = productStore();

  const [rows, setRows] = useState(null);
  const [emptyRows, setEmptyRows] = useState(null);
  const [visibleRows, setVisibleRows] = useState(null);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    if (
      !ProductStore.isLoading &&
      !PaymentStore.isLoading &&
      !OrderStore.isLoading &&
      !UsersStore.isLoading
    ) {
      const myRows = [];
      if (PaymentStore.mPaymentDetails) {
        PaymentStore.mPaymentDetails.map((payment) => {
          let totalQTY = 0;
          let delivery_status = "";
          const productData = [];
          OrderStore.orderDetail.map((order) => {
            if (payment._id === order.paymentID) {
              totalQTY = totalQTY + order.quantity;
              delivery_status = order.order_delivery_status;

              ProductStore.mProduct.map((product) => {
                if (product._id === order.productID) {
                  productData.push({
                    _id: order._id,
                    productName: product.productName,
                    qty: order.quantity,
                    regularPrice: order.purchasePrice,
                    size: order.selectedSize,
                    color: order.selectedColor?.toString(),
                  });
                }
              });
            }
          });
          let username = "";
          let email = "";
          UsersStore.allUser.map((user) => {
            if (user._id === payment.userID) {
              username = user.firstName + " " + user.lastName;
              email = user.email;
            }
          });
          if (delivery_status === "Out Of Delivery") {
            myRows.push({
              _id: payment._id,
              username,
              email,
              orderDate: payment.payment_at,
              totalQTY,
              price: payment.total,
              delivery_status,
              order_products: [...productData],
            });
          }
        });
      }
      if (myRows.length) {
        setRows(myRows);
      }
    }
  }, [
    ProductStore.isLoading,
    PaymentStore.isLoading,
    OrderStore.isLoading,
    UsersStore.isLoading,
  ]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.name);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  useEffect(() => {
    if (rows) {
      const data = stableSort(rows, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      );
      setVisibleRows(data);

      const emptyRowsData =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;
      setEmptyRows(emptyRowsData);
    }
  }, [order, orderBy, page, rowsPerPage, rows]);

  return (
    <div>
      <TableContainer>
        <Table aria-label="collapsible table" size={dense ? "small" : "medium"}>
          <OrderColumn
            numSelected={selected.length}
            order={order}
            orderBy={orderBy}
            onSelectAllClick={handleSelectAllClick}
            onRequestSort={handleRequestSort}
            rowCount={rows ? rows.length : 0}
            dataLoading={dataLoading}
          />
          <TableBody>
            {visibleRows ? (
              visibleRows
                .slice(0)
                .reverse()
                .map((row) => <OrderRow key={row._id} row={row} />)
            ) : (
              <TableRow
                style={{
                  height: (dense ? 33 : 65.5) * 5,
                }}
              >
                <TableCell colSpan={8}>
                  <div className="no-order-data">
                    <div className="content">
                      <DescriptionRoundedIcon className="icon" />
                      <p>{dataLoading ? "Loading..." : "No Data"}</p>
                    </div>
                  </div>
                </TableCell>
              </TableRow>
            )}
            {emptyRows > 0 && (
              <TableRow
                style={{
                  height: (dense ? 33 : 65.5) * emptyRows,
                }}
              >
                <TableCell colSpan={8} />
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={rows ? rows.length : 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
};

export default OutOfDeliveryOrderTab;
